import { useNavigate } from 'react-router-dom';
import { endTour, replayTour, useTourOpen } from '../lib/tour';

/**
 * Turn the first-visit tour on and off from the corner, so it can be looked at
 * without clearing site data to become a first-time guest again.
 *
 * **On** forgets this device has seen it, goes to Now — the only page it runs
 * on — and opens it from the first card. **Off** closes it, which counts as
 * seen, exactly as a guest's Skip does. The switch reads the tour's real state,
 * so finishing or skipping it on screen flips this back off too.
 *
 * **Dev builds only**, like `BackendBadge` and `ClockBar`: `import.meta.env.DEV`
 * is a literal `false` in a real build and the whole component is eliminated.
 * Guests get the same thing from "Show me around again" on Profile.
 *
 * Third in the bottom-left dev stack, above the clock.
 */
export default function TourToggle() {
  if (!import.meta.env.DEV) return null;
  return <Switch />;
}

function Switch() {
  const open = useTourOpen();
  const navigate = useNavigate();

  const flip = () => {
    if (open) { endTour(); return; }
    replayTour();
    navigate('/now');
  };

  return (
    <button
      type="button"
      className={`tour-toggle${open ? ' tour-toggle-on' : ''}`}
      role="switch"
      aria-checked={open}
      onClick={flip}
    >
      <span className="tour-toggle-track" aria-hidden="true"><span /></span>
      First-visit tour
    </button>
  );
}
